import React, { useEffect } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useCoach } from '../hooks/useCoach';

interface CoachPageProps {
  onBack?: () => void;
}

const CoachPage: React.FC<CoachPageProps> = ({ onBack }) => {
  const { coaching, fetchCoaching, loading, error } = useCoach();

  useEffect(() => {
    fetchCoaching();
  }, [fetchCoaching]);

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', mt: 8, p: 3, bgcolor: '#fff', borderRadius: 3, boxShadow: 2, position: 'relative' }}>
      {onBack && (
        <Button
          onClick={onBack}
          variant="text"
          size="small"
          sx={{ position: 'absolute', top: 8, left: 8, minWidth: 0, p: 1 }}
        >
          <CloseIcon sx={{ color: '#222', fontSize: 32 }} />
        </Button>
      )}
      {!loading && !coaching && (
        <Button
          onClick={fetchCoaching}
          variant="text"
          size="small"
          sx={{ position: 'absolute', top: 8, right: 8, minWidth: 0, p: 1 }}
        >
          <RefreshIcon sx={{ color: '#222', fontSize: 28 }} />
        </Button>
      )}
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, mt: 4, textAlign: 'center' }}>
        Coach
      </Typography>
      <Box sx={{ bgcolor: '#f5f5f5', borderRadius: 2, p: 2, minHeight: 220, fontSize: '1.1rem', color: '#333', whiteSpace: 'pre-line' }}>
        {loading && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 200 }}>
            <CircularProgress sx={{ color: '#00A3FF', mb: 2 }} />
            <Typography variant="body1" sx={{ color: '#666' }}>
              Analyzing your data...
            </Typography>
          </Box>
        )}
        {!loading && error && (
          <Typography color="error" sx={{ textAlign: 'center' }}>
            {error}
          </Typography>
        )}
        {!loading && !error && coaching}
      </Box>
    </Box>
  );
};

export default CoachPage;
